function convertJsonOfUpComingGetGpsData(question: any) {
  const {
    centerPoint,
    id,
    title,
    type,
    name,
    description,
    isRequired,
    zoomLevel

  } = question;

  const mapCenterPoint = {
    longitude: centerPoint && centerPoint[0],
    latitude: centerPoint && centerPoint[1],
  };

  const structuredData = {
    _id: id,
    name,
    title,
    type,
    description,
    isRequired,
    zoomLevel:zoomLevel,
    mapCenterPoint,
  };

  return structuredData;
}

export { convertJsonOfUpComingGetGpsData };
